import { css } from '@emotion/css';

export const main = () => css`
  margin-bottom: 0.5rem;
`;
